module.exports = __webpack_public_path__ + "static/img/200124.83e8441d.png";